<template>
  <div id="app">
    <el-container>
      <Header @menu-select="handleMenuSelect" />
      <el-main>
        <router-view />
      </el-main>
    </el-container>
    <ContactFloating />
  </div>
</template>

<script>
import Header from './components/Header.vue';
import ContactFloating from './components/ContactFloating.vue';

export default {
  name: 'App',
  components: {
    Header,
    ContactFloating
  },
  methods: {
    handleMenuSelect(key) {
      // 可以在这里添加其他导航逻辑
      console.log('Menu selected:', key);
    }
  }
};
</script>

<style lang="scss">
@import './assets/scss/functions';
* {
  padding: 0;
  margin: 0;
}

// 设置根字体大小，用于响应式设计
html {
  font-size: 12px; // 降低基础字体大小
  height: 100%;
  
  // 小屏幕设备 (手机)
  @media (max-width: 480px) {
    font-size: 12px;
  }
  
  // 中等屏幕设备 (平板)
  @media (min-width: 481px) and (max-width: 768px) {
    font-size: 12px;
  }
  
  // 笔记本电脑 (13-15寸)
  @media (min-width: 769px) and (max-width: 1440px) {
    font-size: 13px;
  }
  
  // 大屏幕显示器 (17寸以上)
  @media (min-width: 1441px) and (max-width: 1920px) {
    font-size: 14px;
  }
  
  // 超大屏幕设备 (4K等)
  @media (min-width: 1921px) {
    font-size: 16px;
  }
}

// 定义常用的rem值，方便使用
:root {
  // 常用字体大小 (基于14px根字体)
  --font-xs: 0.75rem;    // 10.5px
  --font-sm: 0.875rem;   // 12.25px
  --font-base: 1rem;     // 14px
  --font-lg: 1.125rem;   // 15.75px
  --font-xl: 1.25rem;    // 17.5px
  --font-2xl: 1.5rem;    // 21px
  --font-3xl: 1.875rem;  // 26.25px
  --font-4xl: 2.25rem;   // 31.5px
  --font-5xl: 3rem;      // 42px
  --font-6xl: 3.75rem;   // 52.5px
  
  // 常用间距
  --space-1: 0.25rem;    // 3.5px
  --space-2: 0.5rem;     // 7px
  --space-3: 0.75rem;    // 10.5px
  --space-4: 1rem;       // 14px
  --space-5: 1.25rem;    // 17.5px
  --space-6: 1.5rem;     // 21px
  --space-8: 2rem;       // 28px
  --space-10: 2.5rem;    // 35px
  --space-12: 3rem;      // 42px
  --space-16: 4rem;      // 56px
  --space-20: 5rem;      // 70px
}

body {
  height: 100%;
  font-size: 1rem; // 使用rem单位，相对于html的font-size
}

#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;

  * {
    box-sizing: border-box;
  }
}

.el-main {
  padding: 0 !important;
}

</style>
